<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { formatBytes } from '@/utils/formatBytes'

defineProps<{
  count: number
  bytes: number
  allSelected: boolean
}>()

const emit = defineEmits<{
  'select-all': []
  clear: []
  hide: []
  show: []
  move: []
  delete: []
}>()

const { t } = useI18n()

const buttonClass =
  'rounded-lg px-3 py-1.5 text-sm font-medium text-slate-200 hover:bg-slate-700 transition-colors'
</script>

<template>
  <div
    v-if="count > 0"
    class="fixed inset-x-0 bottom-4 z-30 flex justify-center px-4 pointer-events-none"
    data-testid="gallery-selection-bar"
  >
    <div
      class="pointer-events-auto flex flex-wrap items-center gap-1 rounded-2xl border border-slate-600 bg-slate-800 px-4 py-2.5 shadow-2xl"
      role="toolbar"
      :aria-label="t('galleries.selection.toolbar')"
    >
      <span class="mr-2 text-sm font-semibold text-white" aria-live="polite">
        {{ t('galleries.selection.selected', { count, size: formatBytes(bytes) }) }}
      </span>
      <button v-if="!allSelected" type="button" :class="buttonClass" @click="emit('select-all')">
        {{ t('galleries.selection.select_all') }}
      </button>
      <button type="button" :class="buttonClass" @click="emit('hide')">{{ t('galleries.selection.hide') }}</button>
      <button type="button" :class="buttonClass" @click="emit('show')">{{ t('galleries.selection.show') }}</button>
      <button type="button" :class="buttonClass" @click="emit('move')">{{ t('galleries.selection.move') }}</button>
      <button
        type="button"
        class="rounded-lg px-3 py-1.5 text-sm font-medium text-red-400 hover:bg-slate-700 transition-colors"
        @click="emit('delete')"
      >
        {{ t('galleries.selection.delete') }}
      </button>
      <button type="button" :class="buttonClass" @click="emit('clear')">{{ t('galleries.selection.clear') }}</button>
    </div>
  </div>
</template>
